import React from 'react';

const PartnersPage = () => {
  // Parceiros - apenas com logos reais
  const partners = [
    { 
      id: 1, 
      name: 'Fortinet',
      logo: 'https://customer-assets.emergentagent.com/job_tech-premium/artifacts/twgw98db_images.png'
    },
  ];

  // Integradores - apenas com logos reais
  const integrators = [
    { 
      id: 1, 
      name: 'Microsoft',
      logo: 'https://customer-assets.emergentagent.com/job_tech-premium/artifacts/yuu74ayt_vecteezy_microsoft-logo-on-transparent-background_14018578.jpg'
    },
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="partners-hero">
        <h1 className="page-title">Parceiros & Integradores</h1>
        <p className="page-subtitle">
          Trabalhamos com as principais marcas e integradores do mercado para entregar soluções de excelência
        </p>
      </section>

      {/* Partners Section */}
      <section className="partners-section">
        <div className="partners-content">
          <h2 className="section-title">Nossos Parceiros</h2>
          <p className="section-description">
            Parcerias estratégicas com as principais marcas de tecnologia e segurança do mercado
          </p>
          
          <div className="logos-grid">
            {partners.map((partner) => (
              partner.logo && (
                <div key={partner.id} className="logo-card">
                  <div className="logo-placeholder">
                    <img src={partner.logo} alt={partner.name} />
                  </div>
                  <p className="logo-name">{partner.name}</p>
                </div>
              )
            ))}
          </div>
        </div>
      </section>

      {/* Integrators Section */}
      <section className="integrators-section">
        <div className="integrators-content">
          <h2 className="section-title">Integradores</h2>
          <p className="section-description">
            Integradores certificados que garantem a implementação perfeita de nossas soluções
          </p>
          
          <div className="logos-grid">
            {integrators.map((integrator) => (
              integrator.logo && (
                <div key={integrator.id} className="logo-card">
                  <div className="logo-placeholder">
                    <img src={integrator.logo} alt={integrator.name} />
                  </div>
                  <p className="logo-name">{integrator.name}</p>
                </div>
              )
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnersPage;